import {Imports } from "../editor.interfaces";


/* tslint:disable no-invalid-this */

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

const fabric = globalImports.fabric || (globalImports.fabric = {});
const SF = globalImports.SF || {};
SF.Editor = SF.Editor || {};
globalImports.SF.Editor = globalImports.SF.Editor || {};

globalImports.SF.Editor.Group = fabric.util.createClass(fabric.ActiveSelection, {
    type: 'group',

    // prefixed with sf to not override fabric delegated properties
    sfDelegatedProperties: ['locked'],

    initialize: function (objects: any, options: any): void {
        // initialize
        this.callSuper('initialize', objects, options);

        for (let i = 0; i < this.sfDelegatedProperties.length; i++) {
            const prop = this.sfDelegatedProperties[i];
            // set the property for the class
            this[prop] = this.get(prop);
        }
    },

    /**
     * Override the setter to that size modifications when there is a transformation propagates to objects
     * in the group.
     *
     * @private
     */
    _set: function (key: string, value: any): void {
        if ((key === 'width' || key === 'height') && this.canvas && this.canvas._currentTransform) {
            const posKey = key === 'width' ? 'left' : 'top';

            // convert the change into a scale, and apply it at the object level
            const scale = value / this[key];

            this._objects.forEach(function (object: fabric.Object): void {
                object.set(key, (object[key] || 0) * scale);

                // @todo: this only works for zones that are not rotated
                object.set(posKey, (object[posKey] || 0) * scale);
            });
        }

        this.callSuper('_set', key, value);
    },

    onDeselect: function():boolean|undefined {
        if (this.canvas.getObjects().indexOf(this) < 0) {
            this.destroy();
            return false;
        }
    },

    /**
     * Override the setter so that we can account for storefront delegated properties.
     *
     * @param prop
     * @returns {*}
     */
    get: function (prop: string): any {
        if (this.sfDelegatedProperties.indexOf(prop) >= 0) {
            return this._objects.reduce(function (a: any, b: any): any {
                return a && b[prop];
            }, true);
        }

        return this.callSuper('get', prop);
    },

    /**
     * Change all properties that are relative to the group to be relative to the canvas.
     *
     * @param object
     * @returns {*}
     * @private
     */
    _ungroupifyObject: function (object: any): void {
        // first, backup data for when we groupify again
        object.ify = {
            angle: object.angle,
            left: object.left,
            top: object.top
        };

        // calculate transformations applied by the group
        const matrix = object.calcTransformMatrix();
        const options = fabric.util.qrDecompose(matrix);
        const center = new fabric.Point(options.translateX, options.translateY);

        // apply those transformations to the object
        object.angle = options.angle;
        object.setPositionByOrigin(center, 'center', 'center');

        // return the object
        return object;
    },

    /**
     * Change all properties that are relative to the canvas to be relative to the group.
     *
     * @param object
     * @private
     */
    _groupifyObject: function (object: any): void {
        // if we have a backup from ungroupify, use it here
        if (object.ify) {
            object.set(object.ify);
            delete object.ify;

            return;
        }

        // otherwise, manually calculate position of object inside group
        const objectLeft = object.getLeft();
        const objectTop = object.getTop();
        const center = this.getCenterPoint();

        object.set({
            originalLeft: objectLeft,
            originalTop: objectTop,
            left: objectLeft - center.x,
            top: objectTop - center.y
        });

        object.setCoords();
    },

    _getBoundingRectangle: function (target: any, canvas: any): object {

        const boundingRect = {left: 0, top: 0, width: 0, height: 0};
        boundingRect.left = (target.getBoundingRect().left + this.left) * canvas.getZoom() + canvas.marginLeft;
        boundingRect.top = (target.getBoundingRect().top + this.top) * canvas.getZoom() + canvas.marginTop;
        boundingRect.width = target.getBoundingRect().width * canvas.getZoom();
        boundingRect.height = target.getBoundingRect().height * canvas.getZoom();
        return boundingRect;
    },

    _findGroupByUid: function (canvas: any):undefined|fabric.Object {
        const allObjects = canvas.getObjects();
        for (let i = 0; i < allObjects.length; i++) {
            if (this.uid == allObjects[i].uid) {
                return allObjects[i];
            }
        }
        return undefined;
    },

});